import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

import Intro from 'components/UI/Programs/Intro'
import Speakers from 'components/UI/Programs/Speakers'
import Schedule from 'components/UI/Programs/Schedule'
import Base from 'components/Layout/Base'
import bgImage from 'images/bg-page-conference.jpg'

const Conference = ({ location, data }) => {

    let dateString = `${ new Date(data.strapiProgram.StartDate).getDate() }${ data.strapiProgram.EndDate && data.strapiProgram.EndDate !== data.strapiProgram.StartDate ? ` - ${ new Date(data.strapiProgram.EndDate).getDate() }` : ''} ${ new Date(data.strapiProgram.StartDate).toLocaleString('default', { month: 'long' })  }`

    const Background = () => {
        return (<BackgroundContainer className="w-full h-full "></BackgroundContainer>)
    }

    return (
        <Base pageTitle={ data.strapiProgram.Title } background={<Background />}  location={ location } footerButtonColor="#bbd610" solidFooter={ true }>
            <Intro dateString={ dateString } logo={ data.strapiProgram.Logo.url } text={ data.strapiProgram.ShortDescription} />
            <Schedule title="Schedule" scheduleData={ [...data.allStrapiEventDay.edges.map( item => item.node)] } hideRoomName />
            <Speakers list={[...data.strapiProgram.speakers.filter( item => item.Photo )]} title="Speakers" />
        </Base>
    )
}

const BackgroundContainer = styled.div`
    background-image: url(${ bgImage });
    background-position: bottom-center;
    background-size: cover;
`

export const query = graphql`
    query Conference {
        strapiProgram(Title: {eq: "Conference"}) {
            Logo {
                url
            }
            EndDate
            StartDate
            Title
            ShortDescription
            speakers {
                Name
                Title
                Photo {
                    localFile {
                        childImageSharp {
                            gatsbyImageData(quality: 100, width: 500, formats: WEBP, aspectRatio: 1, backgroundColor: "#cccccc", placeholder: NONE)
                        }
                    }
                }
            }
        }
        allStrapiEventDay(filter: {program: {Title: {eq: "Conference"}}}) {
            edges {
                node {
                    id
                    date
                    chanels {
                    roomName
                    schedule {
                        Speakers {
                            Name
                            Title
                            Order
                        }
                        Start
                        Title
                        Note
                        id
                    }
                    }
                }
            }
        }
    }
`

export default Conference
